export const FETCH_GEO_OPTIONS = {
  SUCCESS: 'FETCH_GEO_OPTIONS_SUCCESS'
};
